import dayjs, { Dayjs } from 'dayjs';
import arLocale from 'dayjs/locale/ar';

/**
 * The DFC Fitness Village journey's two languages. Arabic turns the whole village design
 * right-to-left; every other company stays English and left-to-right.
 */
export type DfcLocale = 'en' | 'ar';

/**
 * Arabic is built but held back until DFC confirm its content. While false the village is English
 * only: no header language switch, and `?lang=ar` links or a stored Arabic choice are ignored.
 */
export const DFC_ARABIC_ENABLED = false;

export type DfcDirection = 'ltr' | 'rtl';

export const isDfcLocale = (value: unknown): value is DfcLocale => value === 'en' || value === 'ar';

export const getDfcDirection = (locale: DfcLocale): DfcDirection =>
  locale === 'ar' ? 'rtl' : 'ltr';

/**
 * dayjs's own `ar` locale writes Arabic-Indic digits (١٢:٣٠). UAE sites — DFC's included — write
 * Western digits next to Arabic month and day names, so the village uses a copy of `ar` without
 * the digit swap. Registered locally: the global dayjs locale stays English.
 */
const DFC_DAYJS_ARABIC = 'ar-dfc';

dayjs.locale(
  {
    ...arLocale,
    name: DFC_DAYJS_ARABIC,
    preparse: (text: string) => text,
    postformat: (text: string) => text,
  } as ILocale,
  undefined,
  true
);

const DAYJS_LOCALE: Record<DfcLocale, string> = { en: 'en', ar: DFC_DAYJS_ARABIC };

/** Formats a date for display in the village's language: "Tue 3 Nov" / "ثلاثاء 3 نوفمبر". */
export const formatDfcDate = (date: Dayjs, format: string, locale: DfcLocale): string =>
  date.locale(DAYJS_LOCALE[locale]).format(format);
